module.exports = __webpack_public_path__ + "static/media/logo.99bf4c68.png";